import React from 'react';
import { Card } from '@/components/ui/card';
import { ArrowRight } from 'lucide-react';

/**
 * Dark mode feature card with vibrant accents
 */
const FeatureCard = ({ 
  icon: Icon, 
  title, 
  description, 
  onClick,
  badge,
  gradient = false,
  className = ""
}) => {
  const cardClasses = gradient
    ? "bg-gradient-to-br from-[#1a1a22] to-[#0f0f15] hover:from-[#1a1a22] hover:to-purple-900/20"
    : "bg-[#1a1a22] hover:bg-[#1a1a22]/80";

  return (
    <Card 
      className={`${cardClasses} border border-purple-500/20 hover:border-purple-500/50 rounded-2xl p-6 transition-all duration-300 hover:shadow-lg hover:shadow-purple-500/20 cursor-pointer group ${className}`}
      onClick={onClick}
    >
      <div className="flex flex-col h-full">
        {/* Icon Container */}
        <div className="flex items-start justify-between mb-4">
          <div className="p-3 bg-gradient-to-br from-purple-600/30 to-cyan-500/30 rounded-xl group-hover:scale-110 transition-transform duration-200 border border-purple-500/20">
            {Icon && <Icon className="w-6 h-6 text-[#4de1ff]" />}
          </div>
          {badge && (
            <span className="text-xs font-semibold px-3 py-1 bg-[#00e6a8]/20 text-[#00e6a8] rounded-full border border-[#00e6a8]/30">
              {badge}
            </span>
          )}
        </div>
        
        {/* Title */}
        <h3 className="text-xl font-semibold text-white mb-2 group-hover:text-[#8d4dff] transition-colors">
          {title}
        </h3>
        
        {/* Description */}
        <p className="text-gray-400 flex-grow mb-4 leading-relaxed">
          {description}
        </p>
        
        {/* Arrow Indicator */}
        {onClick && (
          <div className="flex items-center text-[#4de1ff] font-medium text-sm group-hover:gap-2 gap-1 transition-all">
            <span>Learn more</span>
            <ArrowRight className="w-4 h-4 group-hover:translate-x-1 transition-transform" />
          </div>
        )}
      </div>
    </Card>
  );
};

export default FeatureCard;
